<eb-h2 class="text-center mb-4">
    {{ 'common.resize_picture' | transloco }}
</eb-h2>

<image-cropper
    #cropper
    class="modal-image-cropper__cropper"
    [aspectRatio]="1 / 1"
    [autoCrop]="false"
    [imageFile]="file"
    [maintainAspectRatio]="true"
    format="png"
/>

<div class="d-flex justify-content-center gap-3 align-items-center mt-4">
    <eb-button-with-icon
        [label]="'common.cancel'"
        [size]="'small'"
        (buttonClick)="close()"
        icon="ui/action/symbols/cross"
        iconWidth="24"
    >
        <eb-label
            class="d-flex align-items-center p-1"
            size="lg"
        >
            {{ 'common.cancel' | transloco }}
        </eb-label>
    </eb-button-with-icon>
    <button
        eb-button
        [isV2]="true"
        [size]="'small'"
        (click)="confirm()"
        color="primary-v2"
    >
        {{ 'common.confirm' | transloco }}
    </button>
</div>
